(() => {
  const toggle = document.querySelector('.menu-toggle');
  if (toggle) toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    document.getElementById('MainNav').classList.toggle('is-open', open);
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && toggle) { toggle.setAttribute('aria-expanded', 'false'); document.getElementById('MainNav').classList.remove('is-open'); } });
  document.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
    const image = document.querySelector('.product-main-image img');
    if (!image) return;
    image.src = button.dataset.gallerySrc;
    image.removeAttribute('srcset');
    image.alt = button.dataset.galleryAlt || '';
    document.querySelectorAll('[data-gallery-src]').forEach(b => b.classList.toggle('is-active', b === button));
  }));
  const variants = document.getElementById('VariantSelect');
  if (variants) variants.addEventListener('change', () => {
    const option = variants.selectedOptions[0], available = option.dataset.available === 'true';
    const price = document.querySelector('[data-variant-price]'), add = document.querySelector('.product-add');
    if (price) price.textContent = option.dataset.price;
    if (add) { add.disabled = !available; add.textContent = available ? 'Add to bag' : 'Sold out'; }
    const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
  });
})();
